export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/grayscaleAdjustment.worker.013c1690.worker.js");
}
